<!--<template>
  <div class="main-search critical-component-clear">
    <div class="main-search__header grid">
      <h1
        class="
            main-search__title
            text-heading-2xl
            text-heading-3xl-desktop
            text-center
            col
            xs-span
          "
        v-text="searchHeader"
      />
    </div>
    <collection-grid
      v-if="!klevuFetched"
      :banner="false"
      :current-result-count="currentResultCount"
      :filters="filterManager.filters"
      :liquid="liquid"
      :product-list="liquid.products"
      :product-click-event="productClickEvent"
      :search-more="searchMore"
      :total-results-count="totalResultsCount"
      loading
      @update-search-sort="updateSort"
      @load-more-products="loadMoreProducts"
      @update-filters="updateFilters"
    />

    <collection-grid
      v-else
      :banner="false"
      :current-result-count="currentResultCount"
      :filters="filterManager.filters"
      :liquid="liquid"
      :product-list="productList"
      :product-click-event="productClickEvent"
      :search-more="searchMore"
      :total-results-count="totalResultsCount"
      @update-search-sort="updateSort"
      @load-more-products="loadMoreProducts"
      @update-filters="updateFilters"
    />
  </div>
</template>

<script>

import CollectionGrid from '~async/collection-grid/collection-grid'
import { initKlevu, sanitizedCollectionObject } from '~/apis/klevu'
import {
  applyFilterWithManager,
  FilterManager,
  KlevuDomEvents,
  KlevuFetch,
  KlevuSearchSorting,
  listFilters,
  search,
// eslint-disable-next-line import/no-unresolved
} from '@klevu/core'

/**
 * Vue: Main search (main-search)
 * -----------------------------------------------------------------------------
 * Main search page component.
 * - Static section.
 *
 */
export default {
  name: 'MainSearch',
  components: {
    CollectionGrid,
  },
  props: {
    klevu: {
      type: Object,
      default: () => ({}),
    },
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        blockLength: 0,
        title: '',
        description: '',
        products: [],
        pageInfo: {},

      }),
    },
  },
  data() {
    const { currency } = window.cnvs.store

    return {
      currency,
      productList: [],
      initialResults: null,
      sort: KlevuSearchSorting.Relevance,
      sortOptions: KlevuSearchSorting || [],
      klevuFetched: false,
      filterManager: new FilterManager(),
      totalResultsCount: null,
      currentResultCount: null,
      search: '',
      searchMore: false,
      productClickEvent: null,
    }
  },

  computed: {
    searchHeader() {
      const stringOption = { replace: { search: `'${this.search}'` } }
      return this.productList.length > 0 || this.liquid.products.length > 0
        ? this.$string('search.header', stringOption)
        : this.$string('search.no_results', stringOption)
    },
  },

  async mounted() {
    await initKlevu(this.klevu.url, this.klevu.key)
    await this.fetchProducts()
    this.setKlevuEventListeners()
  },

  methods: {
    async fetchProducts() {
      const params = new URLSearchParams(location.search)
      this.search = params.get('q')

      const searchResults = await KlevuFetch(
        search(
          this.search,
          {
            id: 'search',
            limit: 40,
            sort: this.sort,
            priceFieldSuffix: this.currency,
          },
          listFilters({
            filterManager: this.filterManager,
          }),
          applyFilterWithManager(this.filterManager),
        ),
      )

      if (!searchResults) {
        this.klevuFetched = false
        return
      }

      const result = searchResults.queriesById('search')
      const { totalResultsFound, noOfResults } = result.meta

      this.productList = this.updateCollectionObject(result.records)
      this.totalResultsCount = totalResultsFound
      this.currentResultCount = totalResultsFound < noOfResults ? totalResultsFound : noOfResults
      this.klevuFetched = true
      this.initialResults = result
      this.searchMore = Boolean(result.next)
      this.productClickEvent = result.getSearchClickSendEvent()
    },

    /**
     * Update collection object to match specific markets and languages
     * @param {Object} collection - collection object from Klevu
     */
    updateCollectionObject(collection) {
      const productList = sanitizedCollectionObject(collection)
      const { products } = this.liquid
      const { baseCurrency, currency, language } = window.cnvs.store

      if (baseCurrency === currency && language.includes('en')) {
        return productList
      }

      const updatedList = productList.map((product) => {
        const matchingProduct = products.find(
          (item) => item.selectedOrFirstAvailableVariant.id === Number(product.id),
        )
        const matchingPrices =
          product.compareAtPrice?.amount === matchingProduct?.compareAtPrice?.amount &&
          product.price.amount === matchingProduct?.price?.amount

        if (matchingProduct && !matchingPrices) {
          product.compareAtPrice.amount = matchingProduct.compareAtPrice.amount || 0
          product.price.amount = matchingProduct.price.amount
        }

        product.title = language.includes('en') ? product.title : matchingProduct.title

        return product
      })

      return updatedList
    },

    updateSort(sort) {
      this.sort = sort
      this.fetchProducts()
    },

    async loadMoreProducts() {
      const additionalProducts = await this.initialResults.next({
        filterManager: this.filterManager,
      })

      const searchResult = additionalProducts.queriesById('search')
      const { noOfResults, offset } = searchResult.meta

      this.productList = [
        ...this.productList,
        ...sanitizedCollectionObject(searchResult.records),
      ]
      this.currentResultCount = noOfResults + offset
      this.initialResults = searchResult
      this.searchMore = Boolean(searchResult.next)
    },

    captureClickedProduct(product) {
      this.productClickEvent(product.id, this.liquid.title)
      window.location = product.url
    },

    updateFilters(key, value) {
      this.filterManager.toggleOption(key, value)
    },

    setKlevuEventListeners() {
      document.addEventListener(KlevuDomEvents.FilterSelectionUpdate, this.fetchProducts)
    },

    setSortOptions() {
      const selectedOptions = ['RELEVANCE', 'NAME_ASC', 'NAME_DESC', 'PRICE_ASC', 'PRICE_DESC']
      this.sort = selectedOptions
    },
  },
}
</script>

<style lang="scss">
@import '~async/product-card/product-card';
@import '@/components/pagination';
@import './main-search';
</style>-->


<template>
  <div class="main-search critical-component-clear">
    <div class="main-search__header grid">
      <h1
        class="
            main-search__title
            text-heading-2xl
            text-heading-3xl-desktop
            text-center
            col
            xs-span
          "
        v-text="searchHeader"
      />
    </div>
  

    <klevu-grid
      :banner="false"
      :current-result-count="currentResultCount"
      :filters="filterManager"
      :liquid="liquid"
      :product-list="productList"
      :product-click-event="productClickEvent"
      :search-more="searchMore"
      :total-results-count="totalResultsCount"
      :selectedtags = "selectedTags"
      @update-search-sort="updateSort"
      @load-more-products="loadMoreProducts"
      @update-filters="updateFilters"
    />

   
  </div>
</template>

<script>

import KlevuGrid from '~async/klevu-grid/klevu-grid'
import FilterGrid from '~async/filter-grid/filter-grid'
import searchProduct from '~graphql/searchproduct.gql'
import { formatProductt } from '~/helpers/format'
import {
  KlevuSearchSorting,
} from '@klevu/core'

/**
 * Vue: Main search (main-search)
 * -----------------------------------------------------------------------------
 * Main search page component.
 * - Static section.
 *
 */
export default {
  name: 'MainSearch',
  components: {
    KlevuGrid,
    FilterGrid
  },
  props: {
    klevu: {
      type: Object,
      default: () => ({}),
    },
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        blockLength: 0,
        title: '',
        description: '',
        products: [],
        pageInfo: {},

      }),
    },
  },
  data() {
    const { currency } = window.cnvs.store

    return {
      currency,
      productList: [],
      initialResults: null,
      sort: KlevuSearchSorting.Relevance,
      sortOptions: KlevuSearchSorting || [],
      klevuFetched: false,
      filterManager: null,
      totalResultsCount: null,
      currentResultCount: null,
      allProducts:[],
      selectedTags:[],
      search: '',
      searchMore: false,
      productClickEvent: null,
      loadedCount: 12,
    }
  },

  computed: {
    searchHeader() {
      const stringOption = { replace: { search: `'${this.search}'` } }
      return this.productList.length > 0 || this.liquid.products.length > 0
        ? this.$string('search.header', stringOption)
        : this.$string('search.no_results', stringOption)
    },
  },
  async mounted() {

this.productList = [...this.liquid.products]

      const params = new URLSearchParams(location.search)
      this.search = params.get('q')
      this.fetchProducts()
      this.setSortOptions()

},


  methods: {

    
   async  fetchProducts() {
    if(sessionStorage.getItem('cnvs-query-cache')){
      sessionStorage.removeItem('cnvs-query-cache') 
    }
   
      const params = new URLSearchParams(location.search)
      this.search = params.get('q').toLowerCase()

      try {
        const response = await cnvs.Query({
          query: searchProduct ,
          variables: {
            query: this.search,
            country: cnvs.store.country,
            language: cnvs.store.language
          },
        })
        
        this.allProducts = response?.search?.edges.filter(edge => edge.node && Object.keys(edge.node).length > 0).map(edge => formatProductt(edge.node))
        
        this.productList = this.allProducts.slice(0, this.loadedCount);
        this.totalResultsCount = response?.search?.edges.filter(edge => edge.node && Object.keys(edge.node).length > 0).length < this.loadedCount ? response?.search?.edges.filter(edge => edge.node && Object.keys(edge.node).length > 0).length : this.loadedCount
        this.currentResultCount = this.loadedCount
        this.searchMore = true
        const formatFilter = this.formatFilters(response.search.productFilters)
        this.filterManager = JSON.parse(JSON.stringify(formatFilter))
       
      } catch (error) {
        //console.log('Failed to fetch products', error)
      }
    },

   formatFilters(filters) {
      return filters.map(filter => ({
        name: filter.label, // Ensure JSON formatting
        options: filter.values.map(option => ({
          label: this.cleanLabel(option.label),
          value: option.label,
          count: option.count,
          selected: JSON.stringify(option.active || false),
          paramname: filter.id,
          filtertype: filter.type
        }))
      }));
    },

    // Helper function to clean the label
    cleanLabel(label) {
      return label.replace(/filter:|Filter:/gi, "").trim();
    },

    /**
     * Update collection object to match specific markets and languages
     * @param {Object} collection - collection object from Klevu
     */


    updateSort(sorted) {
      

      if(sorted  === 'PRICE_ASC'){
       let products = [...this.productList]
       products.sort((a, b) => a.price.amount- b.price.amount);
        this.productList = products
      }
      if(sorted  ==='PRICE_DESC'){
       let products = [...this.productList]
       products.sort((a, b) => b.price.amount- a.price.amount);
        this.productList = products
      }
      if(sorted  ==='NAME_ASC'){
       let products = [...this.productList]
       products.sort((a, b) => a.title.localeCompare(b.title));
        this.productList = products
      }
      if(sorted  ==='NAME_DESC'){
       let products = [...this.productList]
       products.sort((a, b) => b.title.localeCompare(a.title));
        this.productList = products
      }
      if(sorted  === 'RELEVANCE'){
        let products =  [...this.allProducts]
        this.productList = products
      }
    },
   
    async loadMoreProducts() {
      if (this.loadedCount < this.allProducts.length) {
      this.loadedCount += 12;  // Increase the count by 12
      this.productList = this.allProducts.slice(0, this.loadedCount);
      this.currentResultCount =   this.loadedCount
      this.totalResultsCount = this.loadedCount
      this.initialResults = this.productList
      this.searchMore = true
      }else{
        this.searchMore = false
      }
    },

    captureClickedProduct(product) {
      this.productClickEvent(product.id, this.liquid.title)
      window.location = product.url
    },

    async updateFilters(key, value) {
      
          let newproducts;
          let productCount;
          let dataval;
          let filterButton = document.getElementById('btn-'+key +'-'+value);
          if (filterButton.classList.contains('selected')) {
            filterButton.classList.remove('selected');
          }else{
            filterButton.classList.add('selected');
          }
       
          const decodeHtmlEntities =(text)=> {
              const doc = new DOMParser().parseFromString(text, "text/html");
              return doc.body.textContent || "";
          }
          const filterProducts = (products, tags, Ids) => {

              const filterByType = Ids.includes('filter.p.product_type');
              const filterByCompatible = Ids.includes('filter.p.m.custom.compatible_with');
              const filterbylength = Ids.includes('filter.v.option.choose blade length');

              return products.filter(product => {
                  let matchesType = true; 
                  let matchesCompatible = true; 
                  let matcheslength = true; 

                  if (filterByType) {
                      matchesType = typeof product.type === 'string' &&
                          tags.some(tag => decodeHtmlEntities(tag.toLowerCase().trim()) === decodeHtmlEntities(product.type.toLowerCase().trim()));
                  }

               
//                  if (filterByCompatible) {
//                      let compatibilityValues = [];
//                      try {
//                          compatibilityValues = product.compatibility
//                              ? JSON.parse(product.compatibility) 
//                              : [];
//                      } catch (error) {
//                          console.error('Error parsing compatibility value:', error);
//                      }
//
//                      matchesCompatible = compatibilityValues.some(compatible => 
//                          tags.some(tag => tag.toLowerCase().trim() == compatible.toLowerCase().trim())
//                      );
//                  }

                     // Compatibility filtering
                   // Compatibility filtering
                    if (filterByCompatible) {
                      // Set default to false if we're filtering by compatibility
                      matchesCompatible = false;

                      // Check if product.compatible_with exists
                      if (product.compatibility) {
                        // If compatible_with is an array
                        if (Array.isArray(product.compatibility)) {
                        
                          if (product.compatibility.length > 0) {
                            const compatibilityTags = product.compatibility
                              .filter(item => item) // Filter out any null/undefined values
                              .flatMap(compatible => typeof compatible === 'string' && compatible.includes('|') ?
                                compatible.split('|') : compatible);

                            matchesCompatible = compatibilityTags.some(tag => tags.includes(tag));
                          
                          }
                        }
                        // If compatible_with is a string
                        else if (typeof product.compatibility === 'string') {
                      
                          const compatibilityTags = product.compatibility.includes('|') ?
                            product.compatibility.split('|') : [product.compatibility];

                          matchesCompatible = compatibilityTags.some(tag => tags.includes(tag));
                          
                        }
                        // For any other data type (number, etc.)
                        else {
                          // Convert to string for comparison
                          matchesCompatible = tags.includes(String(product.compatibility));
                        }
                      } else {
                        console.log('Product has no compatible_with property');
                      }
                    }

                  if (filterbylength && Array.isArray(product.variants) && Array.isArray(tags)) {
                         const matches = product.variants.filter(variant => 
                              tags.some(tag => 
                                  decodeHtmlEntities(tag.toLowerCase().trim()) === variant.title.toLowerCase().trim()
                              )
                          );

                          if (matches.length === 0) {
                              matcheslength = false;
                          }else{
                            matcheslength = true; 
                          }
                        
                    }

                  return matchesType && matchesCompatible && matcheslength;
              });
          };
        
        let checkboxes = document.getElementsByClassName('filter-value__btn');
        let selectedTags = [];
        let selectedIds =[];
         
        for (let x = 0; x < checkboxes.length; x++) {
          if (checkboxes[x].classList.contains('selected')) {
              selectedTags.push(checkboxes[x].value);
              let checkboxId = checkboxes[x].id; 
              let parts = checkboxId.split('-');

                if (parts.length >= 3) { 
                    let key = parts.slice(1, -1).join('-'); 
                    selectedIds.push(key);
                }
                
              }
            }
            
            if (selectedTags.length > 0) {
              this.selectedTags = selectedTags;
            let listProducts = this.allProducts;
            newproducts = filterProducts(listProducts, selectedTags ,selectedIds);
            this.totalResultsCount = newproducts.length
            this.currentResultCount = this.allProducts.length
            this.productList = JSON.parse(JSON.stringify(newproducts));
            this.searchMore = false;
            
          }else{
            this.totalResultsCount = this.loadedCount
            this.currentResultCount = this.allProducts.length
            this.productList =  this.allProducts.slice(0, this.loadedCount);
            this.selectedTags = 0;
            //if (this.totalResultsCount > this.currentResultCount) {
            //  this.searchMore = true;
            //}
            this.searchMore = false;
          }

    },


    //setKlevuEventListeners() {
    //  document.addEventListener(KlevuDomEvents.FilterSelectionUpdate, this.fetchProducts)
    //},

    setSortOptions() {
      const selectedOptions = ['RELEVANCE', 'NAME_ASC', 'NAME_DESC', 'PRICE_ASC', 'PRICE_DESC']
      this.sort = selectedOptions
    },
  },
}
</script>

<style lang="scss">
@import '~async/product-card/product-card';
@import '@/components/pagination';
@import './main-search';
</style>
